// ProductModelGoodInward.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import { ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ProductApi from "../Apis/ProductApi";

const ProductModelGoodInward = ({ SetDepartment }) => {
    const [Products, setProducts] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);
    const [IsReloadproductClicked, setIsReloadproductClicked] = useState(false);

    const handleReloadproductClick = () => {
        setLoading(true);

        if (!SetDepartment?.id) {
            console.warn("No supplier selected");
            setLoading(false);
            return;
        }

        ProductApi.FilterProductsBySupplier(SetDepartment?.id, 0, 100)
            .then((response) => {
                setTotalPageNew(response.totalPages);
                const products = response?.payloadDto || [];
                setAllProducts(products);
                setProducts(products);
                setPage(1);
            })
            .catch((err) => {
                console.log("Filter API error:", err);
            })
            .finally(() => {
                setLoading(false);
            });

        setIsReloadproductClicked(true);
        setTimeout(() => {
            setIsReloadproductClicked(false);
        }, 1000);
    };

    const fetchDepartments2 = async () => {
        setLoading(true);
        try {
            const response = await ProductApi.Listproducts(page, 500);
            setTotalPageNew(response.totalPages);
            const newProducts = response?.payloadDto?.filter(product => 
                product?.supplierDTO && 
                product.supplierDTO.length > 0 && 
                product.supplierDTO[0]?.id === SetDepartment?.id
            ) || [];
            setAllProducts(prev => [...prev, ...newProducts]);
            setProducts(prev => [...prev, ...newProducts]);
            setPage(prevPage => prevPage + 1);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1;
        if ((bottom || nearBottom) && TotalPageNew > page) {
            fetchDepartments2();
        }
    };

    // Search functionality
    const handleSearch = (value) => {
        if (!value || value.trim() === '') {
            setProducts(allProducts);
            return;
        }

        const filtered = allProducts.filter(product => {
            const productName = product?.productName || '';
            const productCode = product?.productCode || '';
            const searchLower = value.toLowerCase();
            
            return productName.toLowerCase().includes(searchLower) ||
                   productCode.toLowerCase().includes(searchLower);
        });
        
        setProducts(filtered);
    };

    useEffect(() => {
        handleReloadproductClick();
    }, [SetDepartment]);

    return (
        <> 
            <div className="row product-row d-flex align-items-center">
                <Form.Item
                    name="productId"
                    label="Product :"
                    className="text-lable pt-3 col-10"
                    rules={[
                        {
                            required: true,
                            message: "Please Select Product.",
                        },
                    ]}
                >
                    <Select
                        className="control-Select mb-1"
                        placeholder="Select Product"
                        showSearch
                        onSearch={handleSearch}
                        onPopupScroll={handleScroll}
                        filterOption={false} 
                        notFoundContent={loading ? "Loading..." : "No products found"}
                    >
                        {Products.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {option.productName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <div className="col-1 d-flex justify-content-center">
                    {IsReloadproductClicked ? (
                        <div className="refresh-btn">
                            <SyncOutlined spin className="px-2" />
                        </div>
                    ) : (
                        <div
                            className="refresh-btn"
                            onClick={handleReloadproductClick}
                            style={{ cursor: "pointer" }}
                        >
                            <ReloadOutlined className="px-2" />
                        </div>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-4"></div>
                <div className="col-6" style={{ paddingLeft: "30px" }}>
                    <Link to={"/product-master-sheet"} target="_blank">
                        <u>Create New Product</u>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default ProductModelGoodInward;